import * as di from "./dirtyInfo";
import get from "lodash.get";
import { set } from "utils/immutable";
import curry from "lodash.curry";

export function create(document, dirtyInfo) {
  return { originalDocument: document, document: document, dirtyInfo: dirtyInfo || di.create() };
}

export const updateProperty = curry((propertyPath, value, changeTrackingDocument) => {
  return value !== get(changeTrackingDocument.document, propertyPath)
    ? {
        ...changeTrackingDocument,
        document: set(propertyPath, value, changeTrackingDocument.document),
        dirtyInfo: di.update(propertyPath, true, changeTrackingDocument.dirtyInfo)
      }
    : changeTrackingDocument;
});

export const update = curry((changes, changeTrackingDocument) => {
  const result = Object.entries(changes).reduce(
    (changeTrackingDocument, [propertyPath, value]) => updateProperty(propertyPath, value, changeTrackingDocument),
    changeTrackingDocument
  );
  return result;
});
